









import { Component, Prop, Vue } from 'vue-property-decorator';
import { Employee, employeeApis, EmployeeQuery } from '@/api';
import * as _ from 'lodash';

@Component
export default class EmployeeSelectM extends Vue {
  @Prop({ required: true }) value!: number;
  localValue: number | string = -1;
  debounceSearch!: (name: string) => void;
  employees: Array<Employee> = [];

  created() {
    this.debounceSearch = _.debounce(this.remoteSearch, 150);
    this.localValue = this.value;
    if (this.localValue > 0) {
      this.search({ id: this.localValue });
    }
  }

  private search(query: EmployeeQuery) {
    employeeApis.search(query).then(employees => {
      for (const emp of employees) {
        (emp as any).value = emp.username;
        (emp as any).title = this.employeeTitle(emp);
      }
      this.employees = employees;
    });
  }

  async remoteSearch(value: string) {
    this.search({ name: value });
  }

  employeeTitle(e: Employee): string {
    let result = e.display_name;
    if (e.position) {
      result += ` - ${e.position}`;
    }
    return result;
  }

  handleChoice(e: Employee) {
    this.localValue = this.employeeTitle(e);
    this.$emit('input', e.id);
    this.employees = [];
  }
}
